import React, { useState } from 'react';
import { CIGAR_PLACEHOLDER } from '../config/constants';

/**
 * CigarImage component that displays cigar images with proper positioning
 * to favor showing the cigar band area (typically in the upper-center portion)
 * Falls back to placeholder on error.
 * 
 * @param {string} src - Image URL
 * @param {string} alt - Alt text for the image
 * @param {string} className - Additional CSS classes
 * @param {string} size - Size preset: 'sm' (list), 'md' (card), 'lg' (detail)
 */
const CigarImage = ({ src, alt = 'Cigar', className = '', size = 'md' }) => {
  const [hasError, setHasError] = useState(false);
  
  // Use placeholder if no src, if there's an error, or if src looks invalid
  const isInvalidSrc = !src || hasError || (src && src.length < 10);
  const imageUrl = isInvalidSrc ? CIGAR_PLACEHOLDER : src;
  const isPlaceholder = isInvalidSrc;
  
  // For user-uploaded cigar photos, position to favor showing the cigar band
  // Cigar bands are typically in the upper-middle portion of photos
  // Use 'center 25%' to show the upper-center area where bands usually appear
  const objectPosition = isPlaceholder ? 'center' : 'center 25%';
  
  const handleError = () => {
    // If image fails to load, show placeholder instead
    setHasError(true);
  };
  
  return (
    <img 
      src={imageUrl} 
      alt={alt}
      className={`w-full h-full object-cover ${className}`}
      style={{ objectPosition }}
      loading="lazy"
      onError={handleError}
    />
  );
};

export default CigarImage;
